import axios from 'axios';

// Smart backend URL detection
function getBackendURL() {
  const envURL = process.env.REACT_APP_BACKEND_URL;
  
  // List of URLs that should be REPLACED with relative path (Production deployments)
  const productionWrongURLs = [
    'https://consortium-products.emergent.host',
  ];
  
  // If envURL is set and it's a known wrong production URL, use relative path
  if (envURL && productionWrongURLs.includes(envURL.trim())) {
    console.log('⚠️ Detected wrong production URL, using relative path instead');
    return '/api';
  }
  
  // If envURL is set and not empty, use it (Preview environment)
  if (envURL && envURL.trim() !== '') {
    console.log('✓ Using configured backend URL:', envURL);
    return `${envURL}/api`;
  }
  
  // Default: Use relative URL (works in Production Kubernetes)
  console.log('✓ Using relative path /api');
  return '/api';
}

const API_URL = getBackendURL();

console.log('🔗 API Base URL:', API_URL);

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data);
    if (error.response?.status === 401) {
      console.log('Unauthorized - clearing session');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (userData) => api.post('/auth/register', userData),
  getMe: () => api.get('/auth/me'),
};

export const productsAPI = {
  getAll: (params) => api.get('/products', { params }),
  getOne: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  importPDF: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/products/import-pdf', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000 // 30 second timeout for upload only
    });
  },
  getPDFImportStatus: (jobId) => api.get(`/products/import-pdf/status/${jobId}`),
  confirmPDFImport: (productsData) => api.post('/products/confirm-pdf-import', productsData),
};

export const questionsAPI = {
  create: (data) => api.post('/questions', data),
  getByProduct: (productId) => api.get(`/questions/product/${productId}`),
  answer: (id, answer) => api.post(`/questions/${id}/answer`, { answer }),
  getUnansweredCount: () => api.get('/questions/unanswered/count'),
};

export const usersAPI = {
  getAll: () => api.get('/users'),
  updateRole: (id, role) => api.put(`/users/${id}/role`, null, { params: { role } }),
};

export const collectionsAPI = {
  getAll: () => api.get('/collections'),
  create: (data) => api.post('/collections', data),
  update: (id, data) => api.put(`/collections/${id}`, data),
};

export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  getUnreadCount: () => api.get('/notifications/unread/count'),
};

export const dashboardAPI = {
  getAdminDashboard: () => api.get('/dashboard/admin'),
  getSalesDashboard: () => api.get('/dashboard/sales'),
};
